/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import './StatusMapBox.css';
import { AiFillWarning, AiFillCheckCircle } from 'react-icons/ai';
import { BsWifiOff } from 'react-icons/bs';

export default function StatusMapBox(props) {
    const { code, childToParent } = props;
    var idParque = (JSON.parse(sessionStorage.getItem("configuration"))[0].idSolarFarm);

    // Muestra u oculta línea de TCU/INV en la tabla según la configuración mientras cargan los datos
    const configuracion = JSON.parse(sessionStorage.getItem("configuration"))[0].enabledLayers;
    let defaultDataArray = [];
    switch(true){
        case configuracion.includes('TCU') && !configuracion.includes('INV'):
            defaultDataArray = [ { "idSolarFarm": idParque, "idDevice": 3, "OK": "0", "Warning": "0", "Alarms": "0", "Comm": "0" } ]
            break;
        case !configuracion.includes('TCU') && configuracion.includes('INV'):
            defaultDataArray = [ { "idSolarFarm": idParque, "idDevice": 2, "OK": "0", "Warning": "0", "Alarms": "0", "Comm": "0" } ]
            break;
        default:
            defaultDataArray = [ { "idSolarFarm": idParque, "idDevice": 2, "OK": "0", "Warning": "0", "Alarms": "0", "Comm": "0" }, { "idSolarFarm": idParque, "idDevice": 3, "OK": "0", "Warning": "0", "Alarms": "0", "Comm": "0" } ];
            break;
    }
    const [data, setData] = useState(defaultDataArray)
    
    const [filter, setFilter] = useState('');

    const [classOINV,setClassOINV] = useState("default");
    const [classWINV,setClassWINV] = useState("default");
    const [classAINV,setClassAINV] = useState("default");
    const [classCINV,setClassCINV] = useState("default");
    const [classOTCU,setClassOTCU] = useState("default");
    const [classWTCU,setClassWTCU] = useState("default");
    const [classATCU,setClassATCU] = useState("default");
    const [classCTCU,setClassCTCU] = useState("default");


    const [boxHtml, setBoxHtml] = useState(
        <tr>
        <td>INV: </td>
        <td>{data[0].OK} <AiFillCheckCircle color={'green'} size={18}/></td>
        <td>{data[0].Warning} <AiFillWarning color={'orange'} size={18}/></td>
        <td>{data[0].Alarms} <AiFillWarning color={'red'} size={18}/></td>
        <td>{data[0].Comm} <BsWifiOff color={'gray'} size={18}/></td>
    </tr>
    )
    

    // Quitar o añadir al filtro 
    function toggleFilter(variable) {
        if(filter.includes(variable) && filter.length > 0) {
            setFilter(filter.replace(variable + ';', ''));
        } else setFilter(filter + variable + ';');
    }

    // Enviar al mapa cada vez que se modifica el filtro
    useEffect(() => {
        childToParent(filter);
    }, [filter]);

    // Carga de datos
    var number = 0;
    useEffect(() => {
        //fetch
        fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/inverterAndTrackerStatusCount?idSolarFarm="+idParque, { method: 'GET', credentials: 'include' })
        .then( async(d) => { 
            let dato = await d.json(); 
            setData(dato);
        })
        .catch(e => {console.log(e);})

        var statusMapBoxInterval = setInterval(() => {
            number++;
            if( sessionStorage.getItem("key")) { // No ha cambiado de página
                // fetch
                fetch(window.location.protocol+"//"+window.location.hostname+"/api" + "/lastData/inverterAndTrackerStatusCount?idSolarFarm="+idParque, { method: 'GET', credentials: 'include' })
                .then( async(d) => { setData(await d.json());})
                .catch(e => {console.log(e);})
            } else {
                clearInterval(statusMapBoxInterval);
            }
        }, 30000);
    },[number]);

    useEffect(()=> {
        if(data !== null) {
            let html = data.map((d, index) => {
                const { idSolarFarm, idDevice, OK, Warning, Alarms, Comm } = d;
                let deviceName = idDevice == 2 ? 'INV' : 'TCU';

                // Cuadros advertencias
                if(idDevice == 2) { // Inversores
                    if(!classWINV.includes('div-status-map-box-filter-selected')) {
                        if(Warning > 0) {
                            setClassWINV('resumen-warning-active');
                        } else {
                            setClassWINV('');
                        }
                    }
                } else { // Trackers
                    if(!classWTCU.includes('div-status-map-box-filter-selected')) {
                        if(Warning > 0) {
                            setClassWTCU('resumen-warning-active');
                        } else {
                            setClassWTCU('');
                        }
                    }
                }

                // Cuadros alarmas
                if(idDevice == 2) { // Inversores
                    if(!classAINV.includes('div-status-map-box-filter-selected')) {
                        if(Alarms > 0) {
                            setClassAINV('resumen-alarms-active');
                        } else {
                            setClassAINV('');
                        }
                    }
                } else { // Trackers
                    if(!classATCU.includes('div-status-map-box-filter-selected')) {
                        if(Alarms > 0) {
                            setClassATCU('resumen-alarms-active');
                        } else {
                            setClassATCU('');
                        }
                    }
                }

                // Cuadros fallo de comunicación
                if(idDevice == 2) { // Inversores
                    if(!classCINV.includes('div-status-map-box-filter-selected')) {
                        if(Comm > 0) {
                            setClassCINV('resumen-fallo-comm-active');
                        } else {
                            setClassCINV('');
                        }
                    }
                } else { // Trackers
                    if(!classCTCU.includes('div-status-map-box-filter-selected')) {
                        if(Comm > 0) {
                            setClassCTCU('resumen-fallo-comm-active');
                        } else {
                            setClassCTCU('');
                        }
                    }
                }


                return(<tr key={index}>
                    <td>{deviceName}: </td>
                    <td className={ idDevice === 2 ? classOINV: classOTCU} title= {`Filtrar por ${deviceName} OK`} 
                    onClick={() => {idDevice === 2 ? setClassOINV(classOINV.includes('div-status-map-box-filter-selected') ? '' : 'div-status-map-box-filter-selected'):setClassOTCU(classOTCU.includes('div-status-map-box-filter-selected')? '' : 'div-status-map-box-filter-selected'); idDevice === 2 ? toggleFilter('INV-OK') : toggleFilter('TCU-OK');}}>{OK} <AiFillCheckCircle color={'green'} size={18}/></td>
                    
                    <td className={ idDevice === 2 ? classWINV : classWTCU} title= {`Filtrar por ${deviceName} en advertencia`} 
                    onClick={() => {idDevice === 2 ? setClassWINV(classWINV.includes('div-status-map-box-filter-selected') ? 'resumen-warning-active' : 'div-status-map-box-filter-selected'):setClassWTCU(classWTCU.includes('div-status-map-box-filter-selected')? '' : 'div-status-map-box-filter-selected'); idDevice === 2 ? toggleFilter('INV-WARNING') : toggleFilter('TCU-WARNING');}}>{Warning} <AiFillWarning color={'orange'} size={18}/></td>
                    
                    <td className={ idDevice === 2 ? classAINV : classATCU} title= {`Filtrar por ${deviceName} en alarma`} 
                    onClick={() => {idDevice === 2 ? setClassAINV(classAINV.includes('div-status-map-box-filter-selected') ? 'resumen-alarms-active' : 'div-status-map-box-filter-selected'):setClassATCU(classATCU.includes('div-status-map-box-filter-selected')? '' : 'div-status-map-box-filter-selected'); idDevice === 2 ? toggleFilter('INV-ALARM') : toggleFilter('TCU-ALARM');}}>{Alarms} <AiFillWarning color={'red'} size={18}/></td>
                    
                    <td className={idDevice === 2 ? classCINV : classCTCU} title= {`Filtrar por ${deviceName} en fallo com.`} 
                    onClick={() =>{ idDevice === 2 ? setClassCINV(classCINV.includes('div-status-map-box-filter-selected') ? 'resumen-fallo-comm-active' : 'div-status-map-box-filter-selected'):setClassCTCU(classCTCU.includes('div-status-map-box-filter-selected')? '' : 'div-status-map-box-filter-selected'); idDevice === 2 ? toggleFilter('INV-COM') : toggleFilter('TCU-COM');}}>{Comm} <BsWifiOff color={'gray'} size={18}/></td>
                </tr>)
            });
            setBoxHtml(html);
        }
    }, [data, classCTCU, classCINV, classAINV, classATCU, classWINV, classWTCU, classOINV, classOTCU]);

    return (
        <div id='div-status-box' className='unselectable'>
            <table>
                <thead className='thead-status-box'>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {boxHtml}
                </tbody>
            </table>
        </div>
    )
}
